export default __webpack_public_path__ + "static/media/yearlyJacket.3d137a78.svg";